import { render, staticRenderFns } from "./Rams.vue?vue&type=template&id=0de68288&"
import script from "./Rams.vue?vue&type=script&lang=js&"
export * from "./Rams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports